module.exports = __webpack_public_path__ + "08bf86699d297d535cf75de12db6e8b8.png";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/widgettypes/charts/c_line_stacked_bar_1week_show_labels.png
// module id = 887
// module chunks = 7